<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<h2 class="text-primary" style="margin-bottom: 0px">
					<i class="fas fa-coins" /> Gerenciar Plano de Contas
				</h2>
			</div>
			<div class="col-md-6 text-right">
				<b-dropdown
					class="ml-2"
					variant="success"
					right
					toggle-class="text-decoration-none"
					no-caret
				>
					<template v-slot:button-content>
						<i class="fas fa-plus" />
						<span class="d-none d-md-inline"> Novo</span>
					</template>

					<b-dropdown-item @click="openPlanGroupForm()">
						<i class="fas fa-folder-plus" /> Novo Grupo Plano de Contas
					</b-dropdown-item>
					<b-dropdown-item @click="openAccountPlanForm()">
						<i class="fas fa-list-ul" /> Novo Plano de Contas
					</b-dropdown-item>
				</b-dropdown>
			</div>
		</div>

		<form @keyup.enter="getAccountsPlans()" @submit.prevent>
			<div class="row pt-3">
				<div class="col-md-4">
					<text-input v-model="search.text" placeholder="Pesquisar" />
				</div>
				<div class="col-md-4">
					<button
						type="button"
						@click="getAccountsPlans()"
						class="btn btn-sm btn-primary"
					>
						<i class="fas fa-search" /> Pesquisar
					</button>
				</div>
			</div>
		</form>
		<br />

		<account-plan-list
			ref="accountPlanList"
			:accountPlans="accountPlans"
			@pagechange="getAccountsPlans($event)"
			@selectGroup="openPlanGroupForm($event)"
			@selectPlan="openAccountPlanForm($event)"
		/>
		<account-plan-form
			ref="accountPlanForm"
			@store="getAccountsPlans($event)"
		/>
		<account-plan-group-form
			ref="accountPlanGroupForm"
			@store="getAccountsPlans($event)"
		/>
	</div>
</template>


<script>
	import accountPlanForm from "../../components/AccountPlan/forms/AccountPlanForm";
	import accountPlanList from "../../components/AccountPlan/lists/AccountPlanList.vue";
	import accountPlanGroupForm from '../../components/AccountPlan/forms/AccountPlanGroupForm.vue';

	export default {
		components: {
			accountPlanForm,
			accountPlanList,
			accountPlanGroupForm
		},

		data() {
			return {
				search: {
					text: null,

				}
			};
		},

		created() {
			this.getAccountsPlans();
		},

		computed: {
			accountPlans() {
				return this.$store.state.accountPlan.accountsPlanGroups;
			}
		},

		methods: {
			openAccountPlanForm(id) {
				this.$refs.accountPlanForm.open(id);
			},

			getAccountsPlans(page = 1) {
				this.search.page = page;
				this.$store
					.dispatch("accountPlan/getAccountsPlanGroups", this.search)
					.then(response => {
						this.$store.commit("pageHasLoaded");
					})
					.catch(error => {
						this.$store.commit("pageHasLoaded");
					});
			},
			openPlanGroupForm(group_id) {
				this.$refs.accountPlanGroupForm.open(group_id)
			}
		}
	};
</script>

<style>
</style>

